import {
  GetItemModelCriteriaMaster,
  PutItemModelCriteriaMaster,
  PostItemModelCriteriaMaster,
  GetItemModelCriteria,
} from '../apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

const endPoint = 'item-model-criteria-master';

export const getCriteriaMaster =
  async (): Promise<GetItemModelCriteriaMaster> => {
    const url = getApiUrl(endPoint);
    const header = getHeader({
      method: 'GET',
    });

    const response = await fetchWithAuth(
      url,
      createHeaderWithCredentials(header),
    );
    return response.data;
  };

export const putCriteriaMaster = async (
  data: PutItemModelCriteriaMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(data),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const postCriteriaMaster = async (
  data: PostItemModelCriteriaMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(data),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteCriteriaMaster = async (
  data: GetItemModelCriteria,
): Promise<void> => {
  const queryParams = new URLSearchParams();

  if (data.itemId) {
    queryParams.append('itemId', data.itemId);
  }
  if (data.modelName) {
    queryParams.append('modelName', data.modelName);
  }

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'DELETE',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
